import { useRef } from "react";
import { createPortal } from "react-dom";
import { useOnClickOutside } from "../custom-hooks";

interface ModalProps {
  modalStyle?: string;
  children: any;
  closeModal?: () => void;
  noCloseOnClick?: boolean;
}

function CustomModal({ modalStyle, children, closeModal }: ModalProps) {
  const ref = useRef(null);

  useOnClickOutside(ref, closeModal);

  const modal = (
    <div className="fixed inset-0 z-[1020] overflow-y-auto overscroll-contain touch-pan-y bg-[#1B1530]/35 backdrop-blur-[2px]">
      <div className="flex min-h-[100dvh] items-center justify-center px-3 py-4 pb-[max(1rem,env(safe-area-inset-bottom))] sm:px-4 sm:py-8">
        <div
          ref={ref}
          className={`mx-auto grid w-full max-w-[min(100vw-1.5rem,36rem)] max-h-[min(92dvh,900px)] overflow-y-auto overscroll-contain ${modalStyle || ''}`}
        >
          <main>{children}</main>
        </div>
      </div>
    </div>
  );

  if (typeof document === "undefined") return modal;
  return createPortal(modal, document.body);
}

export default CustomModal;
